import { useI18n } from '../lib/i18n';

/**
 * The consent for appointment texts, shown directly under the phone
 * field and ONLY once a number has been typed (0055).
 *
 * Unchecked by default, never required: declining it books the
 * appointment exactly as before, with email only. The wording says who
 * sends (Book with Assemble), what (confirmations, reminders, changes,
 * cancellations), that frequency varies, that message and data rates
 * may apply, that STOP and HELP work, that consent is not a condition of
 * purchase, and that mobile information is not shared for marketing.
 * It links the Privacy Policy,
 * the Terms and the SMS information page beside it. The version of this
 * wording is `SMS_CONSENT_VERSION` in @shared/sms; bump it if these
 * words change.
 */
export function SmsConsent({ checked, onChange }: { checked: boolean; onChange: (checked: boolean) => void }) {
  const { t } = useI18n();
  return (
    <div className="sms-consent">
      <label className="small">
        <input type="checkbox" name="sms_opt_in" checked={checked} onChange={(e) => onChange(e.target.checked)} />
        {' '}{t('booking.sms_opt_in')}
      </label>
      <p className="hint sms-consent__links">
        {t('booking.sms_consent_links')}{' '}
        <a href="/legal/privacy-policy" target="_blank" rel="noopener">{t('booking.sms_consent_privacy')}</a>,{' '}
        <a href="/legal/terms-of-service" target="_blank" rel="noopener">{t('booking.sms_consent_terms')}</a>{' '}
        {t('booking.sms_consent_and')}{' '}
        <a href="/legal/sms-messaging" target="_blank" rel="noopener">{t('booking.sms_consent_info')}</a>.
      </p>
    </div>
  );
}
